import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { CHECKOUT_URL } from '../data/content';
export function FinalCTA() {
  return <section className="w-full bg-lavender px-5 py-12 sm:py-16" data-id="element-112" data-mp="c6sklh6qa8cu">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto flex max-w-2xl flex-col items-center rounded-2xl border border-gold/40 bg-card p-8 text-center sm:p-10" data-id="element-113" data-mp="c8byx28tq9bz">
        <h2 className="font-serif-display text-2xl font-bold leading-tight text-plum sm:text-3xl" data-id="element-114" data-mp="vv9qflc7xnol">
          ¿Lista para comenzar a acompañarte de una manera más consciente?
        </h2>
        <p className="mt-4 text-sm leading-relaxed text-plum/75 sm:text-base" data-id="element-115" data-mp="14v6k61dgtcqi">
          Accedé hoy a Aura Viva 2026 y recibí la guía principal, el documento “Empezá acá” y los
          ocho bonos digitales.
        </p>

        <span className="mt-6 font-serif-display text-5xl font-bold leading-none text-plum sm:text-6xl" data-id="element-116" data-mp="2c5g6g6d0l2vy">
          USD 12
        </span>
        <p className="mt-3 text-xs font-medium text-plum/75 sm:text-sm" data-id="element-117" data-mp="2h3ztyb79amqf">
          Pago único · Acceso de por vida · Garantía de 7 días
        </p>

        <div className="mt-7 w-full max-w-md" data-id="element-118" data-mp="2r2gmvdpr9bf4">
          <CTAButton label="SÍ, QUIERO ACCEDER A AURA VIVA 2026" href={CHECKOUT_URL} textClassName="text-[12px] tracking-tight sm:text-[15px] sm:tracking-normal" data-id="element-119" data-mp="2r38k0sz03h7i" />
          <p className="mt-3 text-xs leading-relaxed text-plum/70 sm:text-sm" data-id="element-120" data-mp="300iuwd7wp4bw">
            Disponible para toda Latinoamérica · Conversión automática a tu moneda local antes de
            confirmar la compra
          </p>
        </div>

        <p className="mt-7 font-serif-display text-lg font-bold leading-snug text-plum sm:text-xl" data-id="element-121" data-mp="3errosyiudbuu">
          Tu próximo paso no tiene que ser enorme. Solo tiene que ser{' '}
          <span className="text-aura" data-id="element-122" data-mp="3iqqrech3owj4">posible</span>.
        </p>
      </motion.div>
    </section>;
}